
import CheckoutSuccess from "../components/checkoutSuccess/CheckoutSuccess";

const SuccessCheckout = () => {
  return (
    <div>
      <CheckoutSuccess/>
    </div>
  );
};

export default SuccessCheckout;
